import * as requests from '../api-request'

export const uploadAttachment = async ({ file, chatUuid, projectUuid }) => {
  const formData = new FormData() // eslint-disable-line no-undef
  formData.append('file', file)
  // FormData.append stringifies whatever it is handed, so a null/undefined
  // chatUuid would arrive as the literal 'null' and sail past a truthy
  // server-side check. Send it empty instead, so the server's uuid guard
  // rejects the upload loudly rather than bucketing it under a junk key.
  formData.append('chatUuid', typeof chatUuid === 'string' ? chatUuid : '')
  if (projectUuid) {
    formData.append('projectUuid', projectUuid)
  }
  return requests.toJSON('POST', 'co-pilot/attachments', formData)
}

export const getAttachmentStatus = async (uploadUuid) => {
  return requests.toJSON('GET', `co-pilot/attachments/${uploadUuid}/status`)
}

export const listRecentAttachments = async () => {
  return requests.toJSON('GET', 'co-pilot/attachments')
}

export const previewAttachment = async (sourceUuid) => {
  return requests.toBlob('GET', `co-pilot/attachments/${sourceUuid}/preview`)
}

export const deleteAttachment = async (sourceUuid) => {
  return requests.toJSON('DELETE', `co-pilot/attachments/${sourceUuid}`)
}

// Answers whether an attachment is a finished screenplay, and returns it
// parsed into editor blocks when it is. Lets an agent build the script FROM
// the user's own file instead of generating a new story over the top of it.
export const getAttachmentScreenplay = async (sourceUuid) => {
  return requests.toJSON('GET', `co-pilot/attachments/${sourceUuid}/screenplay`)
}

// Renders a table an agent produced as a PDF. CSV is generated in the client
// (see common/markdown-table) since it needs no rendering; PDF goes through
// the server because @react-pdf/renderer runs there.
export const exportTablePdf = async ({ title, subtitle, headers, rows }) => {
  return requests.toBlob('POST', 'co-pilot/attachments/export/pdf', { title, subtitle, headers, rows })
}
